export default "__VITE_ASSET__CzOY5wdq__"